import { Divider } from '../../divider';
import { styled } from '../../styled';
export var AppBarDivider = styled(Divider, { name: 'QuantumAppBarDivider' })(function (_a) {
    var theme = _a.theme;
    return ({
        height: theme.typography.pxToRem(24),
        borderColor: theme.tokens.color_border_inverse_static,
    });
});
AppBarDivider.defaultProps = {
    orientation: 'vertical',
};
